import { useMissionsTranslation } from '../../../../../ui/hooks';
import ControlPointDuplicateIcon from '@mui/icons-material/ControlPointDuplicate';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { IconButton } from '@mui/material';
import React from 'react';
export const ShiftDetailsAdminActions = ({ shiftId, onEditShift, onDuplicateShift, missionStatus, }) => {
    const { t } = useMissionsTranslation();
    if (missionStatus === 'closed') {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { color: 'primary', 
            // stop propagation of actions to not expand content on click
            onClick: (e) => {
                e.stopPropagation();
                onEditShift(shiftId);
            }, "data-test": 'edit-shift-button', "aria-label": t('shifts.ariaLabels.editShift') },
            React.createElement(DriveFileRenameOutlineIcon, null)),
        React.createElement(IconButton, { color: 'primary', 
            // stop propagation of actions to not expand content on click
            onClick: (e) => {
                e.stopPropagation();
                onDuplicateShift(shiftId);
            }, "aria-label": t('shifts.ariaLabels.duplicateShift'), "data-test": 'duplicate-shift-button' },
            React.createElement(ControlPointDuplicateIcon, null))));
};
